<script>
  import { resolve } from '$app/paths'
  import { page } from '$app/state'
  import { getAuthContext } from '$lib/auth-context.svelte'
  import { supportsNotifications } from '$lib/client/notifications/utils'
  import Logo from '$lib/components/images/Logo.svelte'
  import LogoStar from '$lib/components/images/LogoStar.svelte'
  import Account from './Account.svelte'
  import MainMenu from './MainMenu.svelte'

  const { friends } = getAuthContext()
</script>

<header>
  <a class="home" href={resolve('/')} aria-label="Home">
    <div class="logo">
      <Logo />
    </div>
    <div class="logo-star">
      <LogoStar />
    </div>
  </a>
  <MainMenu />
  <Account />
</header>

{#if page.data.session && supportsNotifications() && $friends.length > 0}
  {#await import('../BrowserNotificationsPrompt.svelte') then c}
    <c.default />
  {/await}
{/if}

<style lang="postcss">
  header {
    display: grid;
    position: relative;
    grid-template-columns: auto 1fr;
    align-items: center;
    gap: 1rem;
    z-index: var(--layer-5);
    padding: 0 var(--size-content-px);
    width: 100%;
    height: var(--size-header-height);
    @media (width > 720px) {
      grid-template-columns: auto auto 1fr;
    }
    @media (width > 1000px) {
      grid-template-columns: 1fr auto 1fr;
    }
  }
  .home {
    display: none;
    margin-left: -0.3rem;
    @media (width > 720px) {
      display: block;
    }
    .logo {
      display: none;
    }
    .logo-star {
      display: block;
    }
    @media (width > 1000px) {
      .logo-star {
        display: none;
      }
      .logo {
        display: block;
      }
    }
    margin-right: 1rem;
    color: var(--color-text);
    & :global(svg) {
      width: auto;
      max-width: none;
      height: 2rem;
    }
  }
</style>
